const headerItems = [
  // All items have been removed as requested.
  // You can add new items for your own site here. For example:
  {  label: 'Home',
    slug: 'home',
    href: 'https://dear.is-a.dev',
   },
]

export default headerItems